import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import { schoolRegisterValidationSchema1 } from "src/components/user/validation/school-register-form-validation";


function SchoolInfoContainer() {
  const { t } = useTranslation();
  type InitialValuesType = {
    facilityFullName: string;
    email: string;
    userName: string;
    password: string;
    confirmPassword: string;
  };
  const initialValues: InitialValuesType = {
    facilityFullName: "",
    email: "",
    userName: "",
    password: "",
    confirmPassword: "",
  };
  const {
    values,
    errors,
    touched,
    handleChange,
    handleSubmit,
    handleBlur,
  } = useFormik({
    initialValues: initialValues,
    validateOnChange: true,
    validateOnBlur: true,
    validationSchema: schoolRegisterValidationSchema1,
    onSubmit: async () => {
      handleSubmit();
    },
  });

  return (
    <div className="flex flex-col items-center justify-center rounded-lg font-ar bg-white max-w-[717px] w-[calc(60vw)] gap-4 h-fit py-8 mobile:py-0 mobile:mt-20 mobile:w-[calc(100vw-32px)] mobile:h-auto drop-shadow-[0_0px_20px_rgba(0,0,0,0.05)]">
      <div className="flex flex-col gap-2 mobile:p-3">
        <p className="flex flex-row items-start mobile:text-mint-500 mobile:text-lg mobile:font-medium">
          {t("schoolInfo.container.primaryInformation")}
        </p>
        <label className="text-zinc700 text-xl leading-[30px] font-arMedium">
          {t("registerForm.component.facilityFullName")}
        </label>
        <input
          value={values.facilityFullName}
          onChange={handleChange}
          onBlur={handleBlur}
          id="facilityFullName"
          type="text"
          className={`${
            touched.facilityFullName && errors.facilityFullName
              ? "border-secondary-50 focus:border-secondary-50"
              : "border-zinc400 focus:border-mint-500"
          } w-[425px] h-[61px] bg-transparent mobile:max-w-[345px] mobile:w-[calc(100vw-48px)] mobile:h-[61px] mobile px-4 py-[17px] rounded-[18px] border placeholder:text-zinc300 placeholder:text-lg placeholder:font-arMedium focus:outline-none caret-mint-500`}
          placeholder={`${t("placeholder.facilityFullName.schoolNameExample")}`}
        ></input>
        {touched.facilityFullName && errors.facilityFullName && (
          <p className="text-base mobile:text-xs font-arMedium text-secondary-50">
            {errors.facilityFullName}
          </p>
        )}
      </div>
      <div className="flex flex-col gap-2">
        <label className="text-zinc700 text-xl leading-[30px] font-arMedium">
          {t("registerForm.component.email")}
        </label>
        <input
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
          id="email"
          type="text"
          className={`${
            touched.email && errors.email
              ? "border-secondary-50 focus:border-secondary-50"
              : "border-zinc400 focus:border-mint-500"
          } w-[425px] h-[61px] bg-transparent mobile:max-w-[345px] mobile:w-[calc(100vw-48px)] mobile:h-[61px] mobile px-4 py-[17px] rounded-[18px] border placeholder:text-zinc300 placeholder:text-lg placeholder:font-arMedium focus:outline-none caret-mint-500`}
          placeholder="a@example.sa"
        ></input>
        {touched.email && errors.email && (
          <p className="text-base mobile:text-xs font-arMedium text-secondary-50">
            {errors.email}
          </p>
        )}
      </div>
      <div className="flex flex-col gap-2">
        <label className="text-zinc700 text-xl leading-[30px] font-arMedium">
          {t("registerForm.component.userName")}
        </label>
        <input
          value={values.userName}
          onChange={handleChange}
          onBlur={handleBlur}
          id="userName"
          type="text"
          className={`${
            touched.userName && errors.userName
              ? "border-secondary-50 focus:border-secondary-50"
              : "border-zinc400 focus:border-mint-500"
          } w-[425px] h-[61px] bg-transparent mobile:max-w-[345px] mobile:w-[calc(100vw-48px)] mobile:h-[61px] mobile px-4 py-[17px] rounded-[18px] border placeholder:text-zinc300 placeholder:text-lg placeholder:font-arMedium focus:outline-none caret-mint-500`}
          placeholder="a-a12"
        ></input>
        {touched.userName && errors.userName && (
          <p className="text-base mobile:text-xs font-arMedium text-secondary-50">
            {errors.userName}
          </p>
        )}
      </div>
      <div className="flex flex-col items-start justify-start font-medium h-[99px] font-ar mobile:px-2.5 mobile:max-w-[345px] mobile:w-full w-[425px]">
        <p className="text-xl text-zinc-700">
          {t("registerForm.component.password")}
        </p>
        <button className="h-[27px] mobile:text-base text-lg text-mint-500 pt-6">
          {t("app.shared.changePassword")}
        </button>
      </div>
    </div>
  );
}

export default SchoolInfoContainer;
